// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PGmp0","controls":"styles_controls__2IknC","charLimit":"styles_charLimit__hlhMZ","input":"styles_input__1CJHs","send":"styles_send__xGoxp"};